@if (svgElement) {
  <div class="icon" [class.inherit-color]="inheritColor" [innerHTML]="svgElement"></div>
}
@if (isMaterialIcon) {
  <mat-icon class="cep-mat-icon" [fontSet]="isOutlined ? 'material-icons-outlined' : ''" [inline]="inline">{{icon}}</mat-icon>
}
